import { createSlice, PayloadAction } from '@reduxjs/toolkit';


interface EmployeeFilter {
  key?: React.Key;
  name?: string;
  doj?: string;
  address?: string;
  grade?: string;
  employeename?: string;
  employeeTypeId?: number;
  firstName?: string;
  lastName?: string;
  reportingTo?: string;
  dept?: string;
  designation?: string;
  status?: string;
  profileUrl?: string;
  reviewStatus?: string;
  officialMailId?: string;
  resignationDate?: string;
  dateOfBirth?: string;
  employeeCode?: string;

}

interface AuthState {
  leaveTableExpand: boolean;
  csvFilterData: EmployeeFilter[]
}

const initialState: AuthState = {
  leaveTableExpand: false,
  csvFilterData: []
};

const userDashboardSlice = createSlice({
  name: 'userDashboard',
  initialState,
  reducers: {
    setLeaveTableExpand: (state, action: PayloadAction<boolean>) => {
      state.leaveTableExpand = action.payload;
    },
    clearLeaveTableExpand: state => {
      state.leaveTableExpand = false;
    },
    setCsvFilterData: (state, action: PayloadAction<EmployeeFilter[]>) => {
      state.csvFilterData = action.payload;
    },
    clearCsvFilterData: (state) => {
      state.csvFilterData = [];
    },
  },
});

export const { setLeaveTableExpand, clearLeaveTableExpand, setCsvFilterData, clearCsvFilterData } = userDashboardSlice.actions;
export default userDashboardSlice.reducer;
